import { TApiResponse } from '@/common/types/response';

import { TStatisticsPortalStoreState } from './types';

export function setVisitsCountByTimeTable(
  state: TStatisticsPortalStoreState,
  res: TApiResponse<TStatisticsPortalStoreState['visitsCountByTimeTable']>,
) {
  state.visitsCountByTimeTable = res.data;
}

export function setVisitsCountByGroupsTable(
  state: TStatisticsPortalStoreState,
  res: TApiResponse<TStatisticsPortalStoreState['visitsCountByGroupsTable']>,
) {
  state.visitsCountByGroupsTable = res.data;
}

export function setVisitsCountByUsersTable(
  state: TStatisticsPortalStoreState,
  res: TApiResponse<TStatisticsPortalStoreState['visitsCountByUsersTable']>,
) {
  state.visitsCountByUsersTable = res.data;
}

export function setAverageVisitsTimeTable(
  state: TStatisticsPortalStoreState,
  res: TApiResponse<TStatisticsPortalStoreState['averageVisitsTimeTable']>,
) {
  state.averageVisitsTimeTable = res.data;
}

export function setViewsCountByTimeTable(
  state: TStatisticsPortalStoreState,
  res: TApiResponse<TStatisticsPortalStoreState['viewsCountByTimeTable']>,
) {
  state.viewsCountByTimeTable = res.data;
}

export function setPagesTable(
  state: TStatisticsPortalStoreState,
  res: TApiResponse<TStatisticsPortalStoreState['pagesTable']>,
) {
  state.pagesTable = res.data;
}

export function setSectionsTable(
  state: TStatisticsPortalStoreState,
  res: TApiResponse<TStatisticsPortalStoreState['sectionsTable']>,
) {
  state.sectionsTable = res.data;
}

export function setUniqueVisitsCountTable(
  state: TStatisticsPortalStoreState,
  res: TApiResponse<TStatisticsPortalStoreState['uniqueVisitsCountTable']>,
) {
  state.uniqueVisitsCountTable = res.data;
}

export function setViewsCountByTimeChartData(
  state: TStatisticsPortalStoreState,
  res: TApiResponse<TStatisticsPortalStoreState['viewsCountByTimeChartData']>,
) {
  state.viewsCountByTimeChartData = res.data;
}

export function setUniqueVisitsCountChartData(
  state: TStatisticsPortalStoreState,
  res: TApiResponse<TStatisticsPortalStoreState['uniqueVisitsCountChartData']>,
) {
  state.uniqueVisitsCountChartData = res.data;
}

export function setAverageVisitsTimeChartData(
  state: TStatisticsPortalStoreState,
  res: TApiResponse<TStatisticsPortalStoreState['averageVisitsTimeChartData']>,
) {
  state.averageVisitsTimeChartData = res.data;
}

export function setVisitsCountByTimeChartData(
  state: TStatisticsPortalStoreState,
  res: TApiResponse<TStatisticsPortalStoreState['visitsCountByTimeChartData']>,
) {
  state.visitsCountByTimeChartData = res.data;
}
